import { DynamicDialogConfig } from "primeng/dynamicdialog";

export const MODAL_DEFAULT_CONFIG: DynamicDialogConfig = {
    closeOnEscape: true,
    modal: true,
    dismissableMask: true,
    showHeader: false,
    maskStyleClass: 'ngprime-modal',
    focusOnShow: false,
};